module.exports = __webpack_public_path__ + "img/logo.8e5d4f8e.png";